'use client'

import AnalyzeChartIcon from '@/components/icons/analyze-chart'
import ChipIcon from '@/components/icons/chip'
import TrophyNewIcon from '@/components/icons/trophy-new'
import { SegmentGroup, SegmentGroupItem } from '@/components/ui/segment-group'
import { usePathname } from '@/navigation'
import { useTranslations } from 'next-intl'

export default function Nav({
  variant,
}: {
  variant: 'enclosed' | 'segmented'
}) {
  const pathname = usePathname()
  const segment = pathname.split('/')[1]

  const t = useTranslations('categories')

  const options = [
    {
      id: 'casino',
      label: t('casino.title'),
      icon: ChipIcon,
      href: '/casino',
    },
    {
      id: 'sports',
      label: t('sports.title'),
      icon: TrophyNewIcon,
      href: '/sports',
    },
    {
      id: 'crypto',
      label: t('trade.title'),
      icon: AnalyzeChartIcon,
      href: '/crypto/futures/BTC',
    },
  ]

  return (
    <SegmentGroup
      value={segment}
      orientation='horizontal'
      variant={variant}
      size='md'
      flexGrow={1}
    >
      {options.map((option) => {
        const Icon = option.icon

        return (
          <SegmentGroupItem
            key={option.id}
            value={option.id}
            href={option.href}
            disabled={option.disabled}
          >
            <Icon
              display={{ base: 'block', md: 'none', lg: 'block' }}
              mr='4px'
              mt='-1px'
              h='18px'
              w='18px'
            />{' '}
            {option.label}
          </SegmentGroupItem>
        )
      })}
    </SegmentGroup>
  )
}
